








































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import ScheduleAssigneCourier from '@/app/ui/views/Pickup/components/ScheduleAssigneCourier/index.vue'
import { DropdownValue } from '@/app/ui/controllers/PickupController'
import { Utils } from '@/app/infrastructures/misc'

export type CrrnfdBulkAssignConfirmPayload = {
  courierId: number
  manualAssignDate?: string
  timeZone?: string
}

@Component({
  components: { Modal, Button, DropdownSelect, ScheduleAssigneCourier },
})
class CrrnfdBulkAssignModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({ type: Number, default: 0 }) readonly senderCount!: number
  @Prop({ type: Number, default: 0 }) readonly totalShipments!: number
  @Prop({ type: Number, default: 0 }) readonly totalKoli!: number
  @Prop({ type: Boolean, default: false }) readonly loadingCouriers!: boolean
  @Prop({ type: Boolean, default: false }) readonly submitting!: boolean
  @Prop({ type: Array, default: () => [] })
  readonly courierOptions!: DropdownValue[]

  selectedCourier: DropdownValue | null = null
  isScheduleManualAssign = false
  scheduleKey = 0
  
  form = {
    manualAssignDate: undefined as Date | undefined,
    manualAssignHour: 0,
    manualAssignMinute: 0,
  }

  get scheduleManualAssignValue(): Date | null {
    if (!this.form.manualAssignDate) return null
    const d = new Date(this.form.manualAssignDate.getTime())
    d.setHours(this.form.manualAssignHour, this.form.manualAssignMinute, 0, 0)
    return new Date(d);
  }

  get canSubmit(): boolean {
    if (this.submitting) return false
    if (
      this.selectedCourier == null ||
      this.selectedCourier.value === undefined
    ) {
      return false
    }
    if (this.isScheduleManualAssign && !this.form.manualAssignDate) {
      return false
    }
    return true
  }

  @Watch('visible')
  onVisibleChange(v: boolean): void {
    if (v) {
      this.scheduleKey += 1
      this.selectedCourier = null
      this.isScheduleManualAssign = false
      this.form.manualAssignDate = undefined
      this.form.manualAssignHour = 0
      this.form.manualAssignMinute = 0
    }
  }

  onCourierInput(val: DropdownValue | null): void {
    this.selectedCourier = val
  }

  public onCourierSearch(q: string): void {
    this.$emit('courier-search', q)
  }

  onToggleScheduleManualAssign(active: boolean): void {
    this.isScheduleManualAssign = active
    if (!active) {
      this.form.manualAssignDate = undefined
    }
  }

  onChangeManualAssignDate(value?: Date): void {
    if (value) {
      this.form.manualAssignDate = new Date(value)
      this.form.manualAssignHour = value.getHours()
      this.form.manualAssignMinute = value.getMinutes()
    } else {
      this.form.manualAssignDate = undefined
    }
  }

  onClose(): void {
    if (this.submitting) return
    this.$emit('close')
  }

  public getISOOffset(date: Date): string {
    const offsetMinutes = -date.getTimezoneOffset();
    const absOffset = Math.abs(offsetMinutes);
    
    const sign = offsetMinutes >= 0 ? "+" : "-";
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');
    
    return `${sign}${hours}:${minutes}`;
  }

  onConfirm(): void {
    if (!this.canSubmit || this.selectedCourier == null) return
    const courierId = Number(this.selectedCourier.value)
    if (!Number.isFinite(courierId)) return

    const payload: CrrnfdBulkAssignConfirmPayload = { courierId }
    if (this.isScheduleManualAssign && this.form.manualAssignDate) {
      const dt = new Date(this.form.manualAssignDate.getTime())
      dt.setHours(
        this.form.manualAssignHour,
        this.form.manualAssignMinute,
        0,
        0
      )
      payload.manualAssignDate = Utils.formatDateWithIDLocale(
        dt.toISOString(),
        'YYYY-MM-DD HH:mm:ss'
      )
      payload.timeZone = this.getISOOffset(dt)
    }
    this.$emit('confirm', payload)
  }
}
export default CrrnfdBulkAssignModal;
